// adding this directive to make sure the output file is using strict mode:

'use strict'

import * as Uppy from './src/index.ts'

globalThis.Uppy = Uppy
